module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.48e65ef.woff2";